import { ArticleHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './RgrTooltip.css';
import { RGR_CERTIFICATE_URL } from '../../constants/links';

export const RgrTooltip = () => {
  const title = 'Агентство входит в РГР';
  const subtitle = `Стандарты качества услуг компании сертифицированы, деятельность застрахована`;

  return (
    <div className={styles['container']}>
      <ArticleHeading4>{title}</ArticleHeading4>
      <a className={styles['link']} href={RGR_CERTIFICATE_URL} target="_blank" rel="noreferrer">
        <UIText2 color="text-main-default">Подробнее</UIText2>
      </a>
      <UIText2>{subtitle}</UIText2>
    </div>
  );
};
